import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pet-found-modal',
  templateUrl: './pet-found-modal.component.html',
  styleUrls: ['./pet-found-modal.component.scss']
})
export class PetFoundModalComponent implements OnInit {
  @Input() petName: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
